// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "async/appvue." + {"558": "0a4db3ef","624": "873af89e","66": "357e37a0","714": "3c4f7a76","739": "ee664595",}[chunkId] + ".js"
}